import { render } from "./EnableGoogle2fa.vue?vue&type=template&id=71c6f20a"
import script from "./EnableGoogle2fa.vue?vue&type=script&lang=js"
export * from "./EnableGoogle2fa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/EnableGoogle2fa.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71c6f20a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71c6f20a', __exports__)) {
    api.reload('71c6f20a', __exports__)
  }
  
  module.hot.accept("./EnableGoogle2fa.vue?vue&type=template&id=71c6f20a", () => {
    api.rerender('71c6f20a', render)
  })

}


export default __exports__